import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

export type TagComponentType = 'brand' | 'error' | 'warning' | 'success' | 'info' | 'neutral';

@Component({
  selector: 'app-tag',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './tag.component.html',
  styleUrl: './tag.component.scss'
})
export class TagComponent {
  readonly type = input<TagComponentType>('info');
  readonly emphasized = input(false);
}
